import {NgModule} from '@angular/core';

import {MzIconMdiDirective} from './icon-mdi.directive';

@NgModule({
  declarations: [
    MzIconMdiDirective,
  ],
  exports: [
    MzIconMdiDirective,
  ],
})
export class MzIconMdiModule {
}
